"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _publisherConsentsSlice = require("../../redux/publisherConsentsSlice");
var _consentsHelper = _interopRequireDefault(require("../../util/consentsHelper"));
var _ConsentsStyled = require("./ConsentsStyled");
var _jsxRuntime = require("react/jsx-runtime");
const Consents = _ref => {
  let {
    error,
    onChangeFn
  } = _ref;
  const {
    publisherConsents,
    checked,
    loading,
    error: generalError
  } = (0, _reactRedux.useSelector)(state => state.publisherConsents);
  const {
    publisherId
  } = (0, _reactRedux.useSelector)(state => state.publisherConfig);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(() => {
    async function getConsents() {
      if (publisherId) {
        const consents = await dispatch((0, _publisherConsentsSlice.fetchPublisherConsents)(publisherId)).unwrap().catch(err => {
          throw new Error(err);
        });
        consents.forEach((consent, index) => {
          if (consent.enabledByDefault) {
            dispatch((0, _publisherConsentsSlice.setChecked)(index));
          }
        });
      }
    }
    getConsents();
  }, [publisherId]);
  (0, _react.useEffect)(() => {
    // validate consents
    onChangeFn(checked, publisherConsents);
  }, [checked, publisherConsents]);
  if (generalError === 'noPublisherId') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConsentsStyled.GeneralErrorStyled, {
      "data-testid": "consents__general-error",
      children: t('Unable to fetch terms & conditions. Publisher is not recognized')
    });
  }
  if (loading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConsentsStyled.ConsentsWrapperStyled, {
      "data-testid": "consents__loader",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {})
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ConsentsStyled.ConsentsWrapperStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_ConsentsStyled.FieldsetStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ConsentsStyled.InvisibleLegend, {
        children: "Consents "
      }), publisherConsents.map((consent, index) => {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
          onClickFn: () => dispatch((0, _publisherConsentsSlice.setChecked)(index)),
          checked: checked[index],
          error: error,
          required: consent.required && !checked[index],
          children: (0, _consentsHelper.default)(consent.label, t) + (consent.required ? '*' : '')
        }, consent.label);
      })]
    }), error && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConsentsStyled.ConsentsErrorStyled, {
      children: error
    })]
  });
};
Consents.propTypes = {
  error: _propTypes.default.string,
  onChangeFn: _propTypes.default.func
};
Consents.defaultProps = {
  error: '',
  onChangeFn: () => null
};
var _default = exports.default = Consents;